const API_LISTS = {

    getAreaList: {
      apiName: '/api/v1/h5/dkb/areas',
      desc: '获取省市区数据',
      method: 'POST',
      params: {},
    },
    
    getCaptchaCode: {
      apiName: '/api/v1/h5/dkb/captcha',
      desc: '获取图片验证码',
      method: 'POST',
      params: {},
    },

    getSendCode: {
      apiName: '/api/v1/h5/sms/send_code',
      desc: 'h5发送短信',
      method: 'POST',
      params: {
        post: [
          {
            param: 'mobile',
            isNeed: 1,
          },
          {
            param: 'valid_mode',
            isNeed: 1,
          },
          {
            param: 'brand',
            isNeed: 0,
          },
        ],
      },
    },

    submitJoinInfo: {
      apiName: '/api/v1/h5/dkb/submit',
      desc: '提交加盟意向',
      method: 'POST',
      params: {
        post: [
          {
            param:"channel",
            isNeed: 0,
          },
          {
            param:"brand",
            isNeed: 1,
          },
          {
            param:"realname",
            isNeed: 1,
          },
          {
            param:"mobile",
            isNeed: 1,
          },
          {
            param:"province",
            isNeed: 1,
          },
          {
            param:"city",
            isNeed: 1,
          },
          {
            param:"quxian",
            isNeed: 1,
          },
          {
            param:"area_id",
            isNeed: 1,
          },
          {
            param:"session_key",
            isNeed: 1,
          },
          {
            param:"captcha",
            isNeed: 1,
          },
          {
            param:"sms_code",
            isNeed: 1,
          },
          {
            param:"uuid",
            isNeed: 1,
          },
        ],
      },
    },
};

module.exports = API_LISTS;
